import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "reply"
const ReplyIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M12 7V4c0-.87-1.034-1.325-1.676-.737l-6 5.5a1 1 0 0 0 0 1.474l6 5.5C10.966 16.325 12 15.87 12 15v-3c4 0 6 1.739 6 4.5 0 1.185-.494 2.366-1.321 3.327C18.691 18.632 20 16.523 20 13.5c0-3-2-6.5-8-6.5Z"
          />
        </svg>
      }
    </span>
  )
}
export default ReplyIcon
